import layerContral from '@/utils/control/layerContral'
export default {
  legends: {
    // 场景名字或者自定义图例
    默认服务: {
      '数据中心': {
        '数据中心': {
          layers: ['中国-数据中心'],
          txt: '数据中心', // 图例组件显示的文字
          img: '/img/legend/ShuJuZhongXin',
          showLegend: true, // 是否在图例组件中显示
          checked: false,
        },
        '数据传输': {
          layers: ['中国-数据传输','中国-数据传输_气泡'],
          txt: '数据传输',
          img: '/img/legend/ShuJuChuanShu',
          showLegend: true,
          checked: false,
        }
      },
      '告警': {
        '告警事件': {
          layers: ['中国-告警_数据传输'],
          txt: '数据传输告警',
          showText: '数据传输',
          img: '/img/legend/ShuJuChuanShu',
          showLegend: true,
          checked: false,
        }
      }
    },
    北京: {
      '数据中心': {
        '数据中心': {
          layers: ['北京-数据中心'],
          txt: '数据中心',
          img: '/img/legend/ShuJuZhongXin',
          showLegend: true,
          checked: false,
        },
        '数据传输': {
          layers: ['北京-数据传输','北京-数据传输_气泡'],
          txt: '数据传输',
          img: '/img/legend/ShuJuChuanShu',
          showLegend: true,
          checked: false,
        }
      },
      '告警': {
        '数据传输': {
          layers: ['北京-告警_数据传输'],
          txt: '数据传输告警',
          showText: '数据传输',
          img: '/img/legend/ShuJuChuanShu',
          showLegend: true,
          checked: false,
        }
      }
    },
    园区: {
      安防: {
        '固定摄像头': {
          layers: ['园区-固定摄像头'],
          txt: '固定摄像头',
          img: '/img/legend/SheXiangTouGuDing',
          showLegend: true,
          checked: false,
        },
        '云台摄像头': {
          layers: ['园区-云台摄像头'],
          txt: '云台摄像头',
          img: '/img/legend/SheXiangTouYunTai',
          showLegend: true,
          checked: false,
        },
        '人脸识别摄像头': {
          layers: ['园区-人脸识别摄像头'],
          txt: '人脸识别摄像头',
          img: '/img/legend/SheXiangTouRenLianShiBie',
          showLegend: true,
          checked: false,
        },
        '门禁设备': {
          layers: ['园区-门禁设备'],
          txt: '门禁设备',
          img: '/img/legend/MenJinShiJian',
          showLegend: true,
          checked: false,
        },
        '可燃气体探测器': {
          layers: ['园区-可燃气体探测器'],
          txt: '可燃气体探测器',
          img: '/img/legend/KeRanQiTiTanCeQi',
          showLegend: true,
          checked: false,
        },
        '消防烟感': {
          layers: ['园区-消防烟感'],
          txt: '消防烟感',
          img: '/img/legend/XiaoFangYanGan',
          showLegend: true,
          checked: false,
        }
      },
      人员: {
        安保人员: {
          layers: ['园区-安保人员'],
          txt: '安保人员',
          img: '/img/legend/AnBaoRenYuan',
          showLegend: true,
          checked: false,
        },
        巡检人员: {
          layers: ['园区-巡检人员'],
          txt: '巡检人员',
          img: '/img/legend/XunJianRenYuan',
          showLegend: true,
          checked: false,
        }
      },
      告警: {
        设备: {
          layers: ['园区-告警_设备'],
          txt: '设备',
          img: '/img/legend/SheBeiGaojing',
          showLegend: true,
          checked: false,
        },
        告警事件: {
          layers: ['园区-告警事件分布'],
          txt: '告警事件',
          img: '/img/legend/GaoJingShiJianFenBu',
          showLegend: true,
          checked: false,
        }
      }
    },
    楼层: {
      安防: {
        '固定摄像头': {
          layers: ['园区-固定摄像头'],
          txt: '固定摄像头',
          img: '/img/legend/SheXiangTouGuDing',
          showLegend: true,
          checked: false,
        },
        '云台摄像头': {
          layers: ['园区-云台摄像头'],
          txt: '云台摄像头',
          img: '/img/legend/SheXiangTouYunTai',
          showLegend: true,
          checked: false,
        },
        '人脸识别摄像头': {
          layers: ['园区-人脸识别摄像头'],
          txt: '人脸识别摄像头',
          img: '/img/legend/SheXiangTouRenLianShiBie',
          showLegend: true,
          checked: false,
        },
        '门禁设备': {
          layers: ['园区-门禁设备'],
          txt: '门禁设备',
          img: '/img/legend/MenJinShiJian',
          showLegend: true,
          checked: false,
        },
        '可燃气体探测器': {
          layers: ['园区-可燃气体探测器'],
          txt: '可燃气体探测器',
          img: '/img/legend/KeRanQiTiTanCeQi',
          showLegend: true,
          checked: false,
        },
        '消防烟感': {
          layers: ['园区-消防烟感'],
          txt: '消防烟感',
          img: '/img/legend/XiaoFangYanGan',
          showLegend: true,
          checked: false,
        }
      },
      人员: {
        安保人员: {
          layers: ['园区-安保人员1'],
          txt: '安保人员',
          img: '/img/legend/AnBaoRenYuan',
          showLegend: true,
          checked: false,
        },
        巡检人员: {
          layers: ['园区-巡检人员1'],
          txt: '巡检人员',
          img: '/img/legend/XunJianRenYuan',
          showLegend: true,
          checked: false,
        }
      },
      容量: {
        空间使用: {
          layers: ['园区-空间使用'],
          txt: '空间使用',
          img: '/img/legend/JiGuiGaoJing',
          showLegend: true,
          checked: false,
        },
        功耗使用: {
          layers: ['园区-功耗使用'],
          txt: '功耗使用',
          img: '/img/legend/JiGuiGongHaoShiYong',
          showLegend: true,
          checked: false,
        },
        承重使用: {
          layers: ['园区-承重使用'],
          txt: '承重使用',
          img: '/img/legend/JiGuiChengZhongZhuTu',
          showLegend: true,
          checked: false,
        },
      },
      能耗: {
        水表: {
          layers: ['园区-水表设备'],
          txt: '水表',
          img: '/img/legend/ShuiBiaoSheBei',
          showLegend: true,
          checked: false,
        },
        电表: {
          layers: ['园区-电表设备'],
          txt: '电表',
          img: '/img/legend/DianBiaoSheBei',
          showLegend: true,
          checked: false,
        },
        燃气表: {
          layers: ['园区-燃气表设备'],
          txt: '燃气表',
          img: '/img/legend/RanQiBiaoSheBei',
          showLegend: true,
          checked: false,
        },
      },
      动环: {
        空调: {
          layers: ['园区-空调'],
          txt: '空调',
          img: '/img/legend/KongTiao',
          showLegend: true,
          checked: false
        },
        环境监测设备: {
          layers: ['园区-环境监测设备'],
          txt: '环境监测设备',
          img: '/img/legend/HuanJingJianCeSheBei',
          showLegend: true,
          checked: false
        },
        温度云图: {
          layers: ['园区-温度云图'],
          txt: '温度云图',
          img: '/img/legend/WenDuYunTu',
          showLegend: true,
          checked: false,
        },
        UPS: {
          layers: ['园区-UPS'],
          txt: 'UPS',
          img: '/img/legend/UPS',
          showLegend: true,
          checked: false
        },
        配电柜: {
          layers: ['园区-配电柜'],
          txt: '配电柜',
          img: '/img/legend/PeiDianGui',
          showLegend: true,
          checked: false
        },
      },
      告警: {
        设备: {
          layers: ['园区-告警_设备'],
          txt: '设备',
          img: '/img/legend/SheBeiGaojing',
          showLegend: true,
          checked: false,
        },
        能耗: {
          layers: ['园区-告警_能耗'],
          txt: '能耗',
          img: '/img/legend/NengHaoGaoJing',
          showLegend: true,
          checked: false
        },
        机柜: {
          layers: ['园区-告警_机柜', '园区-告警_机柜告警实体状态'],
          txt: '机柜',
          img: '/img/legend/JiGuiGaoJing',
          showLegend: true,
          checked: false
        }
      },
      机柜点位:{
        '机柜点位': {
          layers: ['园区-机柜点位'],
          txt: '机柜点位',
          img: '/img/legend/SheXiangTouGuDing',
          showLegend: false,
          checked: false,
        },
      }
    },
    房间: {
      安防: {
        '固定摄像头': {
          layers: ['园区-固定摄像头'],
          txt: '固定摄像头',
          img: '/img/legend/SheXiangTouGuDing',
          showLegend: true,
          checked: false,
        },
        '云台摄像头': {
          layers: ['园区-云台摄像头'],
          txt: '云台摄像头',
          img: '/img/legend/SheXiangTouYunTai',
          showLegend: true,
          checked: false,
        },
        '人脸识别摄像头': {
          layers: ['园区-人脸识别摄像头'],
          txt: '人脸识别摄像头',
          img: '/img/legend/SheXiangTouRenLianShiBie',
          showLegend: true,
          checked: false,
        },
        '门禁设备': {
          layers: ['园区-门禁设备'],
          txt: '门禁设备',
          img: '/img/legend/MenJinShiJian',
          showLegend: true,
          checked: false,
        },
        '可燃气体探测器': {
          layers: ['园区-可燃气体探测器'],
          txt: '可燃气体探测器',
          img: '/img/legend/KeRanQiTiTanCeQi',
          showLegend: true,
          checked: false,
        },
        '消防烟感': {
          layers: ['园区-消防烟感'],
          txt: '消防烟感',
          img: '/img/legend/XiaoFangYanGan',
          showLegend: true,
          checked: false,
        }
      },
      容量: {
        空间使用: {
          layers: ['园区-空间使用'],
          txt: '空间使用',
          img: '/img/legend/JiGuiGaoJing',
          showLegend: true,
          checked: false,
        },
        功耗使用: {
          layers: ['园区-功耗使用'],
          txt: '功耗使用',
          img: '/img/legend/JiGuiGongHaoShiYong',
          showLegend: true,
          checked: false,
        },
        承重使用: {
          layers: ['园区-承重使用'],
          txt: '承重使用',
          img: '/img/legend/JiGuiChengZhongZhuTu',
          showLegend: true,
          checked: false,
        },
      },
      动环: {
        空调: {
          layers: ['园区-空调'],
          txt: '空调',
          img: '/img/legend/KongTiao',
          showLegend: true,
          checked: false
        },
        环境监测设备: {
          layers: ['园区-环境监测设备'],
          txt: '环境监测设备',
          img: '/img/legend/HuanJingJianCeSheBei',
          showLegend: true,
          checked: false
        },
        温度云图: {
          layers: ['园区-温度云图'],
          txt: '温度云图',
          img: '/img/legend/WenDuYunTu',
          showLegend: true,
          checked: false,
        },
        UPS: {
          layers: ['园区-UPS'],
          txt: 'UPS',
          img: '/img/legend/UPS',
          showLegend: true,
          checked: false
        },
        配电柜: {
          layers: ['园区-配电柜'],
          txt: '配电柜',
          img: '/img/legend/PeiDianGui',
          showLegend: true,
          checked: false
        },
      },
      告警: {
        设备: {
          layers: ['园区-告警_设备'],
          txt: '设备',
          img: '/img/legend/SheBeiGaojing',
          showLegend: true,
          checked: false,
        },
        机柜: {
          layers: ['园区-告警_机柜', '园区-告警_机柜告警实体状态'],
          txt: '机柜',
          img: '/img/legend/JiGuiGaoJing',
          showLegend: true,
          checked: false
        },
        机器: {
          layers: ['园区-告警_机器', '园区-告警_机器告警实体状态'],
          txt: '机器',
          img: '/img/legend/JiQiGaoJing',
          showLegend: true,
          checked: false
        },
        能耗: {
          layers: ['园区-告警_能耗'],
          txt: '能耗',
          img: '/img/legend/NengHaoGaoJing',
          showLegend: true,
          checked: false
        },
        端口: {
          layers: ['园区-告警_端口'],
          txt: '端口',
          img: '/img/legend/NengHaoGaoJing',
          showLegend: true,
          checked: false
        },
        // 机柜告警: {
        //   layers: ['园区-机柜告警_实体状态'],
        //   txt: '机柜状态',
        //   img: '/img/legend/JiGuiGaoJing',
        //   showLegend: true,
        //   checked: false
        // },
        // 机器告警: {
        //   layers: ['园区-机器告警_实体状态'],
        //   txt: '机器状态',
        //   img: '/img/legend/JiQiGaoJing',
        //   showLegend: true,
        //   checked: false
        // },
      }
    },
    机柜: {
      // 告警: {
      //   机柜: {
      //     layers: ['园区-告警_机柜'],
      //     txt: '机柜',
      //     img: '/img/legend/JiGuiGaoJing',
      //     showLegend: true,
      //     checked: false
      //   },
      //   机器: {
      //     layers: ['园区-告警_机器'],
      //     txt: '机器',
      //     img: '/img/legend/JiQiGaoJing',
      //     showLegend: true,
      //     checked: false
      //   },
      //   机柜告警: {
      //     layers: ['园区-机柜告警_实体状态'],
      //     txt: '机柜状态',
      //     img: '/img/legend/JiGuiGaoJing',
      //     showLegend: true,
      //     checked: false
      //   },
      //   机器告警: {
      //     layers: ['园区-机器告警_实体状态'],
      //     txt: '机器状态',
      //     img: '/img/legend/JiQiGaoJing',
      //     showLegend: true,
      //     checked: false
      //   },
      // }
    },
    机柜组: {

    },
    设备: {
      // 告警: {
      //   机柜: {
      //     layers: ['园区-告警_机柜'],
      //     txt: '机柜',
      //     img: '/img/legend/JiGuiGaoJing',
      //     showLegend: true,
      //     checked: false
      //   },
      //   机器: {
      //     layers: ['园区-告警_机器'],
      //     txt: '机器',
      //     img: '/img/legend/JiQiGaoJing',
      //     showLegend: true,
      //     checked: false
      //   },
      //   端口: {
      //     layers: ['园区-告警_端口'],
      //     txt: '端口',
      //     img: '/img/legend/NengHaoGaoJing',
      //     showLegend: true,
      //     checked: false
      //   },
      //   机柜告警: {
      //     layers: ['园区-机柜告警_实体状态'],
      //     txt: '机柜状态',
      //     img: '/img/legend/JiGuiGaoJing',
      //     showLegend: true,
      //     checked: false
      //   },
      //   机器告警: {
      //     layers: ['园区-机器告警_实体状态'],
      //     txt: '机器状态',
      //     img: '/img/legend/JiQiGaoJing',
      //     showLegend: true,
      //     checked: false
      //   },
      // },
      // 链路: {
      //   设备链路: {
      //     layers: ['园区-设备链路'],
      //     txt: '设备链路',
      //     img: '/img/legend/SheBeiLianLu',
      //     showLegend: true,
      //     checked: false
      //   },
      //   端口: {
      //     layers: ['园区-端口_实体状态'],
      //     txt: '端口',
      //     img: '/img/legend/NengHaoGaoJing',
      //     showLegend: true,
      //     checked: false
      //   },
      // }
    },

  },
  //'中国', '北京', '园区', '楼层', '房间', '机柜', '设备'
  cardName: {
    默认服务: {
      legendConfig: '默认服务',
      legends: ['数据中心', '数据传输', '数据传输告警'], //, '告警事件'
      sceneName: '默认服务',
      cameraName: '中国',
      spaceLevel: '中国'
    },
    北京: {
      legendConfig: '北京',
      legends: ['数据传输', '数据传输告警', '数据中心'],
      sceneName: '北京',
      cameraName: '北京',
      spaceLevel: '北京'
    },
    园区: {
      legendConfig: '园区',
      legends: ['固定摄像头', '云台摄像头', '人脸识别摄像头', '门禁设备', '可燃气体探测器', '消防烟感', '设备', '告警事件', '安保人员', '巡检人员'],
      sceneName: '园区',
      cameraName: '园区',
      spaceLevel: '园区'
    },
    楼层: {
      legendConfig: '楼层',
      legends: ['固定摄像头', '云台摄像头', '人脸识别摄像头', '门禁设备', '可燃气体探测器', '消防烟感', '安保人员', '巡检人员'],
      sceneName: '园区',
      cameraName: 'F3',
      spaceLevel: '楼层'
    },
    房间: {
      legendConfig: '房间',
      legends: ['固定摄像头', '云台摄像头', '人脸识别摄像头', '门禁设备', '可燃气体探测器', '消防烟感'],
      sceneName: '园区',
      cameraName: '机柜组机房',
      spaceLevel: '房间'
    },
    机柜组机房: {
      legendConfig: '房间',
      legends: ['固定摄像头', '云台摄像头', '人脸识别摄像头', '门禁设备', '可燃气体探测器', '消防烟感'],
      sceneName: '园区',
      cameraName: '机柜组机房',
      spaceLevel: '机柜组机房'
    },
    电池组机房: {
      legendConfig: '房间',
      legends: ['固定摄像头', '云台摄像头', '人脸识别摄像头', '门禁设备', '可燃气体探测器', '消防烟感'],
      sceneName: '园区',
      cameraName: '电池组机房',
      spaceLevel: '电池组机房'
    },
    UPS设备机房: {
      legendConfig: '房间',
      legends: ['固定摄像头', '云台摄像头', '人脸识别摄像头', '门禁设备', '可燃气体探测器', '消防烟感'],
      sceneName: '园区',
      cameraName: 'UPS设备机房',
      spaceLevel: 'UPS设备机房'
    },
    机柜: {
      legendConfig: '机柜',
      legends: [],
      sceneName: '园区',
      cameraName: 'A01-003_SM_机柜组',
      spaceLevel: '机柜'
    },
    'A01-004-04_SM_机柜组': {
      legendConfig: '机柜',
      legends: [],
      sceneName: '园区',
      cameraName: 'A01-004-04_SM_机柜组',
      spaceLevel: '机柜'
    },
    'C03-004-04_SM_设备机柜': {
      legendConfig: '机柜',
      legends: [],
      sceneName: '园区',
      cameraName: 'C03-004-04_SM_设备机柜',
      spaceLevel: '机柜'
    },
    'F06-004-07_SM_设备机柜': {
      legendConfig: '机柜',
      legends: [],
      sceneName: '园区',
      cameraName: 'F06-004-07_SM_设备机柜',
      spaceLevel: '机柜'
    },
    机柜组: {
      legendConfig: '机柜组',
      legends: [],
      sceneName: '园区',
      cameraName: '',
      spaceLevel: '机柜组'
    },
    设备: {
      legendConfig: '设备',
      legends: [],
      sceneName: '园区',
      cameraName: '',
      spaceLevel: '设备'
    },
    机柜点位:{
      legendConfig: '楼层',
      legends: ['机柜点位'],
      sceneName: '园区',
      cameraName: '',
      spaceLevel: '楼层'
    }
  },
  groupImgs: {
    数据中心: '/img/group/ShuJuZhongXin',
    安防: '/img/group/AnFang',
    容量: '/img/group/RongLiang',
    能耗: '/img/group/NengHao',
    动环: '/img/group/DongHuan',
    人员: '/img/group/RenYuan',
    告警: '/img/group/GaoJing',
    链路: '/img/group/LianLu',
  },
  ...layerContral
}